<dialog
  [class]="
    mergeClasses(
      'flex flex-col overflow-hidden rounded-2xl border border-brand-muteShadow bg-brand-white shadow-card',
      panelClass()
    )
  "
  aria-modal="true"
  aria-labelledby="notifications-heading"
>
  <header
    class="flex min-h-20 items-center justify-between border-b border-secondary-mutedLightGray px-6 py-5"
  >
    <h2 id="notifications-heading" class="text-h2 font-bold text-brand-black">
      {{ NOTIFICATION_DROPDOWN_CONST.heading }}
    </h2>

    <button
      type="button"
      class="flex h-9 w-9 items-center justify-center rounded-lg border-none bg-transparent cursor-pointer"
      [attr.aria-label]="NOTIFICATION_DROPDOWN_CONST.closeAriaLabel"
      (click)="closePanel()"
    >
      <img [src]="IMAGE_PATHS.CLOSE" [alt]="ALT_TEXT.CLOSE" loading="lazy" />
    </button>
  </header>

  <section
    [class]="
      mergeClasses(
        'm-0.5 flex flex-col rounded-2xl border border-brand-muteShadow bg-brand-white px-6 py-6 shadow-card',
        contentClass()
      )
    "
    aria-label="Notification list"
  >
    @if (isNotificationsLoading()) {
      <div class="flex min-h-40 items-center justify-center">
        <app-loading-indicator [overlay]="true" [ariaLabel]="UI_CONSTANTS.LOADING_ARIA_LABEL" />
      </div>
    } @else {
      <ul
        [attr.aria-label]="'Notifications, ' + notificationCount() + ' items'"
        [class]="mergeClasses('m-0 flex list-none flex-col overflow-y-auto p-0 pe-1', listClass())"
      >
        @for (notification of notifications(); track notification.id) {
          <li class="list-none">
            <article
              [class]="mergeClasses('flex items-start', itemGapClass())"
              [attr.aria-label]="notification.title + ': ' + notification.shortDescription"
            >
              <div
                class="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border-r border-secondary-mustard bg-gradient-to-br from-neutral-canvas to-secondary-mutedLightGray"
                aria-hidden="true"
              >
                <img [src]="IMAGE_PATHS.NOTIFICATION_CARD" alt="" class="h-6 w-6" loading="lazy" />
              </div>

              <div class="flex flex-col gap-1">
                <h3 class="text-sm font-semibold leading-4 text-brand-gray">
                  {{ notification.title }}
                </h3>
                <p
                  class="quill-content"
                  [class]="mergeClasses('text-base font-semibold text-brand-black', messageClass())"
                  [innerHTML]="notification.shortDescription | safeHtml"
                ></p>
                <time class="text-xs font-medium leading-4 text-brand-gray">
                  {{ notification.timeAgo }}
                </time>
              </div>
            </article>
          </li>
        } @empty {
          <li
            aria-live="polite"
            [class]="
              mergeClasses(
                'list-none flex items-center justify-center rounded-2xl bg-brand-mutedWhite text-center text-sm font-medium text-brand-gray',
                emptyStateClass()
              )
            "
          >
            {{ NOTIFICATION_DROPDOWN_CONST.emptyState }}
          </li>
        }
      </ul>

      <footer
        role="contentinfo"
        [class]="
          mergeClasses(
            'mt-6 flex min-h-12 items-center justify-between border-t border-secondary-mutedLightGray pt-4 text-base font-semibold leading-6 text-brand-primary',
            footerClass()
          )
        "
      >
        <button
          type="button"
          class="border-none bg-transparent p-0 underline cursor-pointer disabled:cursor-not-allowed disabled:text-brand-gray"
          (click)="clearNotifications()"
          [disabled]="notificationCount() === 0"
          [attr.aria-label]="'Clear all ' + notificationCount() + ' notifications'"
          [attr.aria-disabled]="notificationCount() === 0"
        >
          {{ NOTIFICATION_DROPDOWN_CONST.clearAll }}
        </button>

        <button
          type="button"
          class="border-none bg-transparent p-0 underline cursor-pointer"
          (click)="onViewAll()"
          [aria-label]="viewAllText()"
        >
          {{ viewAllText() }}
        </button>
      </footer>
    }
  </section>
</dialog>
